import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./ComplexReactionGame.css";

const TOTAL_ROUNDS = 5;
const TOTAL_BLUE_CIRCLES = 10;


const ComplexReactionGame = () => {
  const navigate = useNavigate();

  const [page, setPage] = useState("game");
  const [circleColor, setCircleColor] = useState("red");
  const [reactionTime, setReactionTime] = useState(0);
  const [wrongClickCount, setWrongClickCount] = useState(0);
  const [results, setResults] = useState([]);
  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);
  const attemptWrongClicksRef = useRef(0);
  const [countdown, setCountdown] = useState(null);

  const circleColorRef             = useRef("red");
  const startTimeRef               = useRef(null);
  const colorChangedRef            = useRef(false);
  const activeTimerRef             = useRef(null);
  const reactionNumberRef          = useRef(0);
  const blueCirclesShownRef        = useRef(0);
  const noOfBlueCirclesRef         = useRef(0);
  const blueCirclesShownInRoundRef = useRef(0);
  const totalColorChangesRef       = useRef(0);
  const wrongClicksRef             = useRef(0);
  const resultsRef                 = useRef([]);
  const wrongClickCountRef         = useRef(0);
  const timeInsightsRef            = useRef([]);
  const timeToGreenRef             = useRef(0);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const setColor = (color) => {
    circleColorRef.current = color;
    setCircleColor(color);
  };

  const clearActive = () => {
    if (activeTimerRef.current) clearTimeout(activeTimerRef.current);
  };

  const changeToOriginal = useCallback(() => {
    clearActive();
    setColor("red");
    colorChangedRef.current = false;
    const timer = 1000 * (Math.floor(Math.random() * 3) + 1);
    activeTimerRef.current = setTimeout(() => colorChange(), timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ KEY FIX: requestAnimationFrame — color screen-ல தெரிஞ்ச அப்புறம் timer start
  const colorChange = useCallback(() => {
    clearActive();

    let fillColor;
    if (blueCirclesShownInRoundRef.current < noOfBlueCirclesRef.current) {
      fillColor = "blue";
      blueCirclesShownInRoundRef.current += 1;
    } else {
      fillColor = "green";
    }

    setColor(fillColor);

    // ✅ Double rAF: React paint முடிஞ்ச உடனே timer start — no extra delay
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        startTimeRef.current = performance.now();
        colorChangedRef.current = true;
      });
    });

    if (fillColor === "blue") {
      totalColorChangesRef.current += 1;
      activeTimerRef.current = setTimeout(() => changeToOriginal(), 1000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeToOriginal]);

  const setInitialCircle = useCallback(() => {
    clearActive();
    colorChangedRef.current = false;
    setColor("red");

    blueCirclesShownInRoundRef.current = 0;
    totalColorChangesRef.current = 0;

    const timer = 1000 * (Math.floor(Math.random() * 4) + 3);
    timeToGreenRef.current += timer;

    const rn = reactionNumberRef.current;
    const shown = blueCirclesShownRef.current;

    let noOfBlues;
    if (rn === 0) {
      noOfBlues = Math.floor(Math.random() * (TOTAL_BLUE_CIRCLES - 7 + 1));
    } else if (rn > 0 && rn < 4) {
      const maxBlue = TOTAL_BLUE_CIRCLES - shown - (TOTAL_ROUNDS - rn);
      noOfBlues = Math.floor(Math.random() * (maxBlue + 1));
    } else {
      noOfBlues = TOTAL_BLUE_CIRCLES - shown;
    }

    noOfBlueCirclesRef.current = noOfBlues;
    blueCirclesShownRef.current += noOfBlues;

    activeTimerRef.current = setTimeout(() => colorChange(), timer);
  }, [colorChange]);

  const handleCircleClick = useCallback(() => {
    // ✅ colorChangedRef false-ஆ இருந்தா click ignore — rAF set ஆகல
    if (!colorChangedRef.current) {
      wrongClicksRef.current += 1;
      attemptWrongClicksRef.current += 1;
      wrongClickCountRef.current += 1;
      setWrongClickCount(prev => prev + 1);
      clearActive();
      activeTimerRef.current = setTimeout(() => setInitialCircle(), 1000);
      return;
    }

    const currentColor = circleColorRef.current;

    if (currentColor === "blue") {
      wrongClicksRef.current += 1;
      attemptWrongClicksRef.current += 1;
      wrongClickCountRef.current += 1;
      setWrongClickCount(prev => prev + 1);
      clearActive();
      setColor("red");
      colorChangedRef.current = false;
      activeTimerRef.current = setTimeout(() => setInitialCircle(), 1000);

    } else if (currentColor === "green") {
      // ✅ endTime இங்க எடுக்கணும் — click instant-ஆ catch பண்ணும்
      const endTime = performance.now();
      clearActive();

      const timeDiff = (endTime - startTimeRef.current) / 1000;

      reactionNumberRef.current += 1;

      timeInsightsRef.current.push({
        ReactionNumber: reactionNumberRef.current,
        ReactionTime: timeDiff,
        IncorrectColorChanges: totalColorChangesRef.current,
        TimeToGreen: timeToGreenRef.current,
        WrongClicks: wrongClicksRef.current,
      });

      timeToGreenRef.current = 0;
      wrongClicksRef.current = 0;
      const attemptWrongClicks =
  attemptWrongClicksRef.current;

const newResults = [
  ...resultsRef.current,
  {
    result: Number(
      timeDiff.toFixed(3)
    ),
    wrongClick:
      attemptWrongClicks
  }
];

timeToGreenRef.current = 0;
wrongClicksRef.current = 0;
attemptWrongClicksRef.current = 0;

      resultsRef.current =
        newResults;

      setResults(newResults);
      setReactionTime(timeDiff.toFixed(3));



// 5 → 1 Countdown

if (reactionNumberRef.current === TOTAL_ROUNDS) {
  // Last round → result மட்டும்
  setPage("result");
  return;
}

// Remaining rounds மட்டும் countdown
setCountdown(5);
return;
    }
  }, [setInitialCircle]);

useEffect(() => {
  if (countdown === null) return;

  if (countdown > 1) {
    const timer = setTimeout(() => {
      setCountdown(countdown - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }

  if (countdown === 1) {
    const timer = setTimeout(() => {
      setCountdown(null);

      // இங்க தான் Red
      setColor("red");
      colorChangedRef.current = false;

      if (reactionNumberRef.current < TOTAL_ROUNDS) {
        setInitialCircle();
      } else {
        setPage("result");
      }
    }, 1000);

    return () => clearTimeout(timer);
  }
}, [countdown, setInitialCircle]);
const fetchLeaderboard = useCallback(async () => {
  try {
    const email = localStorage.getItem("rg_email");

    const res = await axios.get(
      `/complexleaderboard?email=${email}`
    );

    setLeaderboard(res.data.leaderboard || []);
    setUserRank(res.data.userRank);

  } catch (error) {
    console.error("Leaderboard fetch error:", error);
  }
}, []);

const saveGameData = useCallback(async () => {
  try {

    const email = localStorage.getItem("rg_email");

    await axios.post("/save-complex-reaction", {
      email,
      results: resultsRef.current,
      wrongClickCount: wrongClickCountRef.current,
      timeInsights: timeInsightsRef.current,
    });

    await fetchLeaderboard();

  } catch (error) {
    console.error("Error saving data:", error);
  }
}, [fetchLeaderboard]);

useEffect(() => {
  fetchLeaderboard();
}, [fetchLeaderboard]);

useEffect(() => {
  if (page === "result") {
    saveGameData();
  }
}, [page, saveGameData]);

  useEffect(() => {
    const email = localStorage.getItem("rg_email");
   
    const authed = localStorage.getItem("rg_auth") === "1";
    if (!email ||!authed) {
      navigate("/complex-reaction");
      return;
    }
    setInitialCircle();
    return () => clearActive();
  }, [navigate, setInitialCircle]);

  const handleExit = async () => {
    clearActive();
    
    navigate("/complex-reaction");
  };

  const handleTryAgain = () => {
    reactionNumberRef.current          = 0;
    blueCirclesShownRef.current        = 0;
    noOfBlueCirclesRef.current         = 0;
    blueCirclesShownInRoundRef.current = 0;
    totalColorChangesRef.current       = 0;
    wrongClicksRef.current             = 0;
    resultsRef.current                 = [];
    wrongClickCountRef.current         = 0;
    timeInsightsRef.current            = [];
    timeToGreenRef.current             = 0;

    setPage("game");
    setWrongClickCount(0);
    setReactionTime(0);
    setResults([]);
    colorChangedRef.current = false;
    setColor("red");

    setInitialCircle();
  };

  const validAttempts = results.map(Number).filter(t => t >= 0.150 && t <= 1);
  const currentAverage =
    validAttempts.length > 0
      ? validAttempts.reduce((a, b) => a + b, 0) / validAttempts.length
      : null;

  return (
    <div className="containerr">

      {page === "game" && (
        <div className="game-containerr">
          <div className={`circler ${circleColor}`} onClick={handleCircleClick} />
          <p className="reaction-timer">
            Reaction Time: {reactionTime ? (reactionTime * 1000).toFixed(0) : "--"} ms
          </p>
          <p className="round-counter">
            Round: {reactionNumberRef.current + 1} / {TOTAL_ROUNDS}
          </p>
          <p className="countdownr">
              {countdown !== null ? `Countdown: ${countdown}` : "\u00A0"}
            </p>
          <p className="wrong-clickr">Wrong Clicks: {wrongClickCount}</p>
        </div>
      )}

      {page === "result" && (
        <div className="result-big-container">

          <div className="leaderboard-box">
            <h3>Leaderboard</h3>
            <table className="leaderboard-table">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Best Reaction</th>
                  <th>Medal</th>
                </tr>
              </thead>
              <tbody>
                {leaderboard.slice(0, 5).map((player, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{player.name}</td>
                    <td>{(player.bestReaction * 1000).toFixed(0)} ms</td>
                    <td>{["🥇","🥈","🥉"][index] || ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {userRank && (
              <div className="your-rank-box">
                Your Rank: {userRank.rank}<br />
                Avg Reaction: {currentAverage ? (currentAverage * 1000).toFixed(0) : "--"} ms<br />
                
              </div>
            )}
          </div>
          

          <div className="results-box">
            <h2>Your Attempts</h2>
            <ul>
              {results.map((item, index) => (
                <li key={index}>
                  Attempt {index + 1}: {(item.result * 1000).toFixed(0)} ms
                  {" | "}
                  Wrong: {item.wrongClick}
                </li>
              ))}
            </ul>
            <button onClick={handleTryAgain} className="try-again-buttonr">Try Again</button>
            <button onClick={handleExit} className="exit-buttonr">Exit</button>
          </div>

        </div>
      )}

    </div>
  );
};

export default ComplexReactionGame;